import { createSelector } from 'reselect';
import { get, values, pipe, sortBy, lowerCase } from 'lodash/fp';

const datasetsSelector = createSelector(
  get('datasets'),
  pipe(values, sortBy(pipe(get('name'), lowerCase))),
);

export default datasetsSelector;
